import StageManager from "../../../../lib/html5-software-library/src/ranj/performance/StageManager";
import AbstractCommand from "./AbstractCommand";
import AppModel from "./AppModel";

export default class InterruptGameCommand extends AbstractCommand {
    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {StageManager} stageManager
     * @param {AppModel} appModel
     */
    constructor(dispatcher, stageManager, appModel) {
        super(dispatcher);

        this._stageManager = stageManager;
        this._appModel = appModel;
    }

    execute(evt) {
        if (this._appModel.isInterrupted) {
            return;
        }

        this._appModel.isInterrupted = true;

        console.log(`[InterruptGameCommand] Interrupt Game!`);

        const exceptStageIds = [];
        const isDeepFreeze = true;
        // freeze Stages
        this._stageManager.freeze(exceptStageIds, isDeepFreeze);

        const stages = this._stageManager.getStages();
        for (const stage of Object.values(stages)) {
            // create screenshot to replace Canvas
            this._createScreenshotForStage(stage);
            // hide Stage
            stage.visible = false;
            // disable Stage mouse interactions
            stage.mouseEnabled = false;
            stage.mouseChildren = false;
        }
    }

    _createScreenshotForStage(stage) {
        const screenshotDataUrl = stage.canvas.toDataURL("image/png");
        const image = new Image();
        image.src = screenshotDataUrl;
        image.style.position = "absolute";
        image.style.top = "0";
        image.style.left = "0";
        image.style.width = "100%";
        image.style.height = "100%";
        image.style.objectFit = "contain";
        image.style.pointerEvents = "none";
        stage.canvas.insertAdjacentElement("afterend", image);
        return image;
    }
}

